import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Global } from '../global/globalApi';

import { LoggedInUserInfo } from '../models/login';
import { LogService } from './log.service';
import { RootScopeService } from './root-scope.service';
import * as Constants from './../models/Constants';

@Injectable({
  providedIn: 'root',
})
export class NewAgentApiService {
  public loginUserInfoDeatils: LoggedInUserInfo = new LoggedInUserInfo();
  constructor(
    private _http: HttpClient,
    private logger: LogService,
    private rootScope: RootScopeService
  ) {}
  /*Get Api call @apiUrl,@param,@isShowMsg,@ismicroService */
  getApi(
    apiUrl: string,
    param,
    isShowMsg: string,
    isMicroSerive: boolean
  ): Observable<any> {
    let url = param == null ? apiUrl : this.formURLParam(apiUrl, param);
    return this.httpConnection('GET', url, isShowMsg, isMicroSerive, Constants.apiVersions);
  }
  postApi(
    apiUrl: string,
    param: Object,
    isShowMsg,
    apiVersion: string,
    isMicroSerive
  ): Observable<any> {
    return this.httpConnection(
      'POST',
      apiUrl,
      isShowMsg,
      isMicroSerive,
      apiVersion,
      param
    );
  }
  putApi(
    apiUrl: string,
    param: Object,
    isShowMsg,
    isMicroSerive
  ): Observable<any> {
    return this.httpConnection(
      'PUT',
      apiUrl,
      isShowMsg,
      isMicroSerive,
      Constants.apiVersions,
      param
    );
  }
  deleteApi(apiUrl: string, param, isShowMsg: string, isMicroSerive: boolean) {
    let url = param == null ? apiUrl : this.formURLParam(apiUrl, param);
    return this.httpConnection('GET', url, isShowMsg, isMicroSerive, Constants.apiVersions);
  }
  private formURLParam(url, param: Object) {
    let queryString: string = '';
    for (const key in param) {
      if (param.hasOwnProperty(key)) {
        if (queryString == '') {
          queryString = '?' + key + '=' + param[key];
        } else {
          queryString += '&' + key + '=' + param[key];
        }
      }
    }
    return url + queryString;
  }

  private httpConnection(
    requestType: String,
    url: string,
    isShowMsg: string,
    isMicroSerive: boolean,
    apiVersion: string,
    body?
  ) {
    let objRequest: any;
    let api: any; //   .append('Connection', "keep-alive")//.append('Accept-Encoding', "gzip,deflate,br")

    let headers = this.rootScope.getCommonHeaders(apiVersion);
    api = Global.domainUrl + url;

    let httpParams = new HttpParams().set('isShowMsg', isShowMsg.toString());

    if (requestType == 'GET') {
      objRequest = this._http.get<any>(api, {
        headers: headers,
        params: httpParams,
      });
    } else if (requestType == 'POST') {
      objRequest = this._http.post<any>(api, body, {
        headers,
        params: httpParams,
      });
    } else if (requestType == 'PUT') {
      objRequest = this._http.put<any>(api, body, {
        headers,
        params: httpParams,
      });
    }
    return objRequest.pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  errorValidation(res) {
    return res.httpStatusCode == HttpStatusCode.Ok ? res.data : null;
  }
}
